module.exports = __webpack_public_path__ + "files/3532899322dcd75921eb7113bf42c700.png";